/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useT } from 'talkr';
import OnlyOneOption from '../../../components/onlyOneOption';
import steps from '../../../survey/steps';
import defaultOption from '../../styles/defaultOption.module.scss';
import common from '../../index.module.scss';
import s from './index.module.scss';
import optionsImages from '../../../survey/optionsImages';

function DefaultQuestion(props) {
  const { T } = useT();
  const dispatch = useDispatch();
  const { options, name } = props.step;
  const { 
    withIcon, 
    roundedOptions, 
    withDescriptionText, 
    noWideIcons,
  } = props;
  const imgAtRightSide = props.design ? defaultOption.imgAtRightSide : '';
  const noWideIconsClass = noWideIcons ? s.noWideIcons : '';

  useEffect(() => {
    name === 'puppy_or_adult' && dispatch({
      type: 'IS_STATUSBAR_TRANSPARENT',
      payload: false,
    });
  });

  function actionOnClick() {
    setTimeout(() => {
      steps.navigate.forward({
        preventAction: 500,
      });
    }, 300);
  }

  return (
    <section className={`${common.step} ${roundedOptions ? s.roundedOptions : ''}`}>
      <div className={`${common.stepTitle} ${s.stepTitle}`}>{T(`${name}_title`)}</div>

      { withDescriptionText && (
        <div className={`${s.descriptionText}`}>{T(`${name}_description`)}</div>
      )}

      <div className={s.options}>
        {
          options && Object.entries(options).map((option) => {
            const imgSrc = optionsImages[name][option[1].value];
            const withDescription = option[1].description;
            return (
              <div className={s.optionWrapper}>
                <OnlyOneOption
                  key={option[1].value}
                  className={`${defaultOption.option} ${s.option} ${s.optionWithArrow} ${withDescription ? s.withDescription : ''} ${props.isExpandedDesign} ${imgAtRightSide}`}
                  selectedStateClass={s.optionWithArrowSelected}
                  option={option[1]}
                  questionName={name}
                  actionOnClick={actionOnClick}
                  disableFromFocus={!props.isThisCurrentStep}
                  runOnChoose={() => { steps.userMovedToNextStepByClick({ byNextStep: true }); }}
                  design={props.design}
                >
                  {withIcon && (
                  <div className={`${s.iconWrapper} ${noWideIconsClass}`}>
                    <img className={s.icon} src={imgSrc} alt="" />
                  </div>
                  )}
                  {T(`${name}_${option[1].value}`)}
                </OnlyOneOption>
              </div>
            );
          })
        }
      </div>
    </section>
  );
}

function WithOneOption(props) {
  const questions = useSelector((state) => state.questions.list);
  const questionName = props.stepData.name;
  const question = questions[questionName];
  const { 
    isThisCurrentStep, 
    isCurrentStepCompleted, 
    withIcon, 
    roundedOptions,
    withDescriptionText,
    noWideIcons,
  } = props;
  const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
  const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';
  const isExpandedDesign = props.isExpandedDesign ? s.designExpanded : '';
  const config = useSelector((state) => state.steps.config);
  const withoutDescription = config === 'short';
  
  return (
    <div className={`${s.step} ${isThisCurrentStepClass} ${isThisStepCompletedClass}`}>
      <DefaultQuestion
        design={props.design}
        step={question}
        index={1}
        isThisCurrentStep={isThisCurrentStep}
        isExpandedDesign={isExpandedDesign}
        withoutDescription={withoutDescription}
        withIcon={withIcon}
        roundedOptions={roundedOptions}
        withDescriptionText={withDescriptionText}
        noWideIcons={noWideIcons}
      />
    </div>
  );
}

export default WithOneOption;
